import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { getPaymentsMdaCount } from "common/services/payments.service";
import { Link, useParams } from "react-router-dom";
import MdaModal from "pages/MDAs/MdaModal";

const TotalActivePartners = () => {
  const { id: agencyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalActivePartners, setTotalActivePartners] = useState(0);
  const [totalPartners, setTotalPartners] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsMdaCount({
          agencyId,
        });
        setTotalPartners(response?.mdaCount);
      } catch (error) {
        console.warn("Error fetching total active partners", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [agencyId]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsMdaCount({
          agencyId,
          active: true,
        });
        setTotalActivePartners(response?.mdaCount);
      } catch (error) {
        console.warn("Error fetching total active partners", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [agencyId]);

  const percentageValue = useMemo(() => {
    if (totalPartners === 0) return 0;
    return (totalActivePartners / totalPartners) * 100;
  }, [totalActivePartners, totalPartners]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  const filter = {
    agency: {
      value: agencyId,
      label: "",
    },
    // status: "active",
  };
  return (
    <Link to="#" onClick={toggleModal}>
      <Card className="card-animate">
        <CardBody>
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">Total Active MDAs</p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value" data-target="33.48">
                  <CountUp
                    start={0}
                    end={totalActivePartners}
                    decimals={0}
                    duration={2}
                  />
                </span>
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-success mb-0">
                  {/* <i className="ri-arrow-up-line align-middle"></i>  */}
                  {percentageValue.toFixed(2)}%
                </span>{" "}
                of total MDAs
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="globe" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      <MdaModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Total Partners"
        filter={filter}
      />
    </Link>
  );
};

export default TotalActivePartners;
